import axios from 'axios';

const API_URL =
  process.env.REACT_APP_API_URL ||
  'https://ghltoluxsciapi.yourframework.health/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 errors (unauthorized) — only redirect when not already on login request
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes('auth/login') ?? false;
      if (!isLoginRequest) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
  getApiLogs: (search = '', page = 1, limit = 10) =>
    api.get('/dashboard/api-logs', { params: { search, page, limit } }),
  getBaskPatients: (search = '', page = 1, limit = 10, tag = 'all') =>
    api.get('/dashboard/bask-patients', {
      params: { search, page, limit, tag },
    }),
  getBaskGhlOpportunityLogs: (search = '', page = 1, limit = 10) =>
    api.get('/dashboard/bask-ghl-opportunity-logs', {
      params: { search, page, limit },
    }),
  getBaskOrders: (search = '', page = 1, limit = 10) =>
    api.get('/dashboard/bask-orders', { params: { search, page, limit } }),
  getBaskOrderLogs: (search = '', page = 1, limit = 10, action = '') =>
    api.get('/dashboard/bask-order-logs', {
      params: { search, page, limit, ...(action && { action }) },
    }),
  getBaskPaymentLogs: (search = '', page = 1, limit = 10) =>
    api.get('/dashboard/bask-payment-logs', {
      params: { search, page, limit },
    }),
  getBaskSmsLogs: (search = '', page = 1, limit = 10) =>
    api.get('/dashboard/bask-sms-logs', {
      params: { search, page, limit },
    }),
  getBaskAbandonedSessionLogs: (search = '', page = 1, limit = 10) =>
    api.get('/dashboard/bask-abandoned-session-logs', {
      params: { search, page, limit },
    }),
  getBaskNorthbeamOrders: (search = '', page = 1, limit = 10, status = 'all') =>
    api.get('/dashboard/bask-northbeam-orders', {
      params: { search, page, limit, status },
    }),
  syncNow: () => api.post('/dashboard/sync'),
};

export default api;

